import Swiper from 'swiper';
import { Navigation, Virtual, A11y } from 'swiper/modules';
import 'swiper/css';

const defaultOptions = {
    modules: [Navigation, Virtual, A11y],
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 16,
    grabCursor: true,
    pagination: false,
    navigation: false,

    breakpoints: {
        768: {
            slidesPerView: 2.5,
        },
        1280: {
            enabled: false,
        }
    },

	a11y: {
        prevSlideMessage: 'Forrige slide',
        nextSlideMessage: 'Næste slide',
    },
};

let mobileSwipers = [];

function initMobileSwipers() {
	if (window.innerWidth < 1280) {
		document.querySelectorAll('.mobile-swiper').forEach((swiperEl) => {

			if (!swiperEl || swiperEl.swiper) return;

			const swiperInstance = new Swiper(swiperEl, {
				direction: 'horizontal',
				loop: false,
				slidesPerView: 1.5,
				spaceBetween: 20,
				grabCursor: true,
				breakpoints: {
					601: {
						slidesPerView: 2.5,
					},
				},
			});
			mobileSwipers.push(swiperInstance);
		});
	} else {
		destroyMobileSwipers();
	}
}

function destroyMobileSwipers() {
	mobileSwipers.forEach((swiper) => swiper.destroy(true, true));
	mobileSwipers = [];
}


document.addEventListener('DOMContentLoaded', function () {
	initMobileSwipers();

	window.addEventListener('resize', function () {
		initMobileSwipers();
	});
});
